<template>
	<InvoicesTable @failed-fetch="handleFetchError" />
	<BalanceTable @failed-fetch="handleFetchError" class="mt-30" />
	<CreditTopupsTable @failed-fetch="handleFetchError" class="mt-30" />
</template>

<script>
import InvoicesTable from "@/console-new/components/config/administration/InvoicesTable.vue";
import {useNotificationStore} from "@/shared/stores";
import BalanceTable from "@/console-new/components/config/administration/BalanceTable.vue";
import CreditTopupsTable from "@/console-new/components/config/administration/CreditTopupsTable.vue";
import {useUserStore} from "@/user/stores";

export default {
	setup() {
		return {showNotification: useNotificationStore().showNotification, userStore: useUserStore()}
	},
	name: "QromoTablesContainer" ,
	components: {BalanceTable, InvoicesTable, CreditTopupsTable},
	methods: {
		handleFetchError(details) {
			if(details && details !== 'not_connected') {
				let msg = details === 'auth_denied' ? 'auth-denied-error' : 'generic-fail';
				if(details === 'refund_limit_exceeded') {
					msg = 'refund-limit-exceeded-error';
				}
				this.showNotification(msg);
			}
		},
	},
	mounted() {
		if(!this.userStore.businessUsers || !Object.keys(this.userStore.businessUsers).length) {
			this.userStore.getBusinessUsers();
		}
	},
	watch: {
		'userStore.currBusinessId': function (newVal, oldVal) {
			if (newVal !== null && newVal !== oldVal) {
				this.userStore.getBusinessUsers();
			}
		}
	}
}
</script>

<style scoped lang="scss">

</style>